import FooterSSR from "@/components/Footer/FooterSSR";
import { NavbarSSR } from "@/components/Header/components/NavbarSSR";
import { FixedContactButton } from "@/components/FixedContactButton/FixedContactButton";
import { FOOTER_BOTTOM_LINKS } from "@/constants/footerData";
import Link from "next/link";

interface RootLayoutSSRProps {
	children: React.ReactNode
	layoutData?: {
		navigationMenu?: any[]
		contactInfo?: any
		officeLocations?: any[]
		footerNavigation?: any[]
	}
}

export default function RootLayoutSSR({
	children,
	layoutData = {},
}: RootLayoutSSRProps) {
	const {
		navigationMenu = [],
		contactInfo,
		officeLocations = [],
		footerNavigation = [],
	} = layoutData

	return (
		<>
			<NavbarSSR navigationMenu={navigationMenu} />
			<FixedContactButton />
			<main id='main-content'>
				{children}
			</main>
			<footer className='bg-accent-color-three-dark text-white max-md:pb-12 footer_ssr'>
					<div className='px-6 py-12 desktop:px-32 desktop:py-16'>
						<FooterSSR
							contactInfo={contactInfo}
							officeLocations={officeLocations}
							footerNavigation={footerNavigation}
						/>
						{/* Footer Bottom */}

					<div className='border-t border-accent-color-two pt-6'>
						<div className='flex flex-col gap-6 desktop:gap-16 desktop:flex-row desktop:justify-between'>
							<div className='text-center text-span-small'>
								<p className='mb-3 font-sans'>
									<strong className='font-bold'>
										Dr. Solomon serves facial plastic surgery patients from
										Frisco, Plano, Prosper, Celina, North Dallas, and the
										greater Dallas–Fort Worth area.
									</strong>
								</p>
								<p className='mb-5 font-sans'>
									His practice welcomes patients from across Texas and
									surrounding states who seek natural, refined results in
									aesthetic and reconstructive plastic surgery.{' '}
									<Link href='/contact/' className='underline'>
										Contact
									</Link>{' '}
									Solomon Plastic Surgery today to schedule your consultation.
								</p>
							</div>
						</div>
					</div>

						<div className='border-t border-accent-color-two pt-6'>
							<div className='flex flex-col gap-6 desktop:gap-16 desktop:flex-row desktop:justify-between'>
								<div className='flex flex-col md:flex-row gap-y-6 gap-x-3 justify-center md:justify-start'>
									{FOOTER_BOTTOM_LINKS.map(link => (
										<a
											key={link.title}
											href={link.href}
											className='hover:underline text-span-medium text-white text-center md:text-nowrap'
										>
											{link.title}
										</a>
									))}
								</div>
								<div className='text-center md:text-left desktop:text-right text-span-small text-accent-color-two copyright-text'>
									<p>
										Copyright © 2026 Solomon Clinic of Plastic Surgery. All
										Rights Reserved. Web Design and Digital Marketing by{' '}
										<a
											href='https://www.webtoolsgroup.com/'
											target='_blank'
											rel='noopener noreferrer'
										>
											Webtools Group
										</a>
										.
									</p>
								</div>
							</div>
						</div>
					</div>
				</footer>
		</>
	)
}